const SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const SCHEMELESS_HOST_WITH_PORT =
  /^(?:localhost|(?:[^\/:?#\s]+\.)+[^\/:?#\s]+|\[[0-9a-f:.]+\]):\d+(?:[/?#]\S*)?$/i;
const RAW_CONTROL_OR_SPACE = /[\u0000-\u0020\u007f]/;
const ENCODED_CONTROL = /%(?:0[0-9a-f]|1[0-9a-f]|7f)/i;
const VALID_PERCENT_ESCAPE = /%[0-9a-f]{2}/gi;

export function normalizeHttpUrlInput(value) {
  const candidate = `${value || ""}`.trim();
  if (!candidate || candidate.startsWith("//")) {
    return candidate;
  }

  if (SCHEMELESS_HOST_WITH_PORT.test(candidate)) {
    return `https://${candidate}`;
  }

  if (SCHEME.test(candidate)) {
    return candidate;
  }

  return `https://${candidate}`;
}

export function safeHttpUrl(value) {
  const candidate = normalizeHttpUrlInput(value);
  if (
    !candidate ||
    candidate.startsWith("//") ||
    candidate.includes("\\") ||
    RAW_CONTROL_OR_SPACE.test(candidate) ||
    ENCODED_CONTROL.test(candidate) ||
    candidate.replace(VALID_PERCENT_ESCAPE, "").includes("%")
  ) {
    return "";
  }

  try {
    const parsed = new URL(candidate);
    if (
      !["http:", "https:"].includes(parsed.protocol) ||
      !parsed.hostname ||
      parsed.username ||
      parsed.password
    ) {
      return "";
    }
  } catch {
    return "";
  }

  return candidate;
}

export function safeNavigationUrl(value) {
  const candidate = `${value || ""}`.trim();
  if (candidate.startsWith("/") && !candidate.startsWith("//")) {
    return RAW_CONTROL_OR_SPACE.test(candidate) ? "" : candidate;
  }

  return safeHttpUrl(candidate);
}
